export default __webpack_public_path__ + "static/media/image.c0a44e87.png";